<template lang="pug">
AppPopover(
  ref="AppPopover"
  placement="bottom-end"
  :lazy="lazy"
  @show="focusInput"
  @hide="resetInput"
)
  span(slot="body")
    .limits-popover-wrapper
      label.control-label
        | {{ weekly ? "This week's limit" : "Today's limit" }}
      ValidationObserver(ref="observer")
        ValidationProvider(
          v-slot="{ errors }"
          :rules="`required|greaterThanZero|max_value:${maxValue}`"
        )
          .form-group.mb-5(:class="{ 'has-error': errors[0] }")
            .input-group
              AppInput(
                v-if="weekly"
                ref="inputRef"
                v-model="thisWeekLimit"
              )
              AppInput(
                v-else
                ref="inputRef"
                v-model="todayLimit"
              )
              span.input-group-addon {{ weekly ? 'hrs/wk' : 'hrs/day' }}
            span.help-block {{ errors[0] }}
      .popover-footer.pt-0
        small
          a.limit-apply-link.cursor-pointer(@click="applyChange") Apply
  span(slot="trigger")
    slot(name="trigger")
</template>

<script>
import { MAX_DAILY_LIMIT, MAX_WEEKLY_LIMIT } from '../../app_constants';
import { mapActions } from 'vuex';
import { mapFormFields } from '~/utils/form_utils';

export default {
  name: 'MemberDialogTabLimitsPopover',
  props: {
    limitType: {
      type: String,
      required: true,
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      MAX_DAILY_LIMIT,
      MAX_WEEKLY_LIMIT,
    };
  },
  computed: {
    ...mapFormFields('membership', {
      thisWeekLimit: 'limits.this_week_limit',
      todayLimit: 'limits.today_limit',
      thisWeekExpected: 'limits.this_week_expected',
    }),
    maxValue() {
      return this.weekly ? this.MAX_WEEKLY_LIMIT : this.MAX_DAILY_LIMIT;
    },
    weekly() {
      return this.limitType === 'weekly';
    },
  },
  methods: {
    ...mapActions([
      'setDailyAllowedHours',
      'setWeeklyAllowedHours',
      'setExpectedAllowedHours',
      'updateCurrentWeeklyLimit',
      'updateCurrentWeeklyExpected',
      'updateCurrentDailyLimit',
    ]),
    close() {
      this.$refs.AppPopover.close();
    },
    async applyChange() {
      const validated = await this.$refs.observer.validate();

      if (validated) {
        if (this.weekly) {
          this.updateCurrentWeeklyLimit(this.thisWeekLimit * 3600);
        } else {
          this.updateCurrentDailyLimit(this.todayLimit * 3600);
        }

        this.close();
        this.$emit('limit-change', this.limitType);
      }
    },
    focusInput() {
      setTimeout(() => {
        this.$refs.inputRef.focus();
      }, 10);
    },
    resetInput() {
      this.$refs.observer.reset();

      if (this.weekly) {
        this.setWeeklyAllowedHours();
      } else {
        this.setDailyAllowedHours();
      }
    },
  },
};
</script>
